"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ShortcutsGroup_1 = __importDefault(require("./ShortcutsGroup"));
exports.default = ShortcutsGroup_1.default;
